/* @ngInject */

export default (
  $q,
  $rootScope,
  helperService,
  helperPdfService,
  homeLoanService,
  quickToolService,
  dateTimeService,
  householdsService,
  INSTANCE
) => ({
  createHomeLoanMaximumBorrowing: ({
    maximumBorrowing,
    lenders,
    filteredLenders,
    documents,
    contacts,
    spouses,
    ticket,
    isQuickTool,
    isView
  }) => {
    const deferred = $q.defer();
    const currentOrganization = $rootScope.CurrentOrganization;
    const currentAccount = $rootScope.CurrentAccount;
    const currentCurrency = $rootScope.CurrentCurrency();
    const currentTimeZone = $rootScope.CurrentTimeZone();

    const getSpouse = ({ keySpouse }) => {
      const spouse = _.find(spouses, (s) => s?.id === keySpouse);
      if (spouse && spouse?.id) {
        return spouse.getName() || '-';
      }
      const idx = _.findIndex(maximumBorrowing?.contacts || [], (c) => c?.key === keySpouse);
      return idx > -1 ? `Applicant #${idx + 1}` : '-';
    };

    const getLender = ({ abbr, isName }) => {
      const lender = _.find(lenders, (l) => l.abbr.toLowerCase() === abbr.toLowerCase());
      if (isName) {
        return lender ? lender.name : 'N/A';
      }
      return lender ? lender.id : '';
    };

    const getCreditCardRepayment = ({ liability, contactKey }) => {
      let repayment = 0;
      const idLender = getLender({ abbr: liability.lenderAbbr, isName: false });
      if (idLender) {
        const currentContact = _.find(maximumBorrowing.contacts, (c) => c.key === contactKey);
        if (currentContact) {
          const value =
            liability.balance >= liability.limit ? liability.balance : liability.limit;
          repayment = _.divide(_.multiply(value || 0, 3.8), 100);
        }
      }
      return repayment;
    };

    const setLiabilityRow = ({ liabilityData, liabilityType, contactKey }) => {
      const liability = liabilityData;
      if (contactKey) {
        liability.repayment = getCreditCardRepayment({
          liability,
          contactKey
        });
      }
      const row = [
        {
          text: getLender({ abbr: liability.lenderAbbr, isName: true }),
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        },
        {
          text: liabilityType,
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        },
        {
          text: liability.balance.formatWithCurrency(currentCurrency),
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        },
        {
          text: liability.limit.formatWithCurrency(currentCurrency),
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        },
        {
          text: liability.repayment.formatWithCurrency(currentCurrency),
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        }
      ];
      return row;
    };

    const getLenderDocument = ({ idLender }) => {
      const doc = _.find(documents, (d) =>
        d.lender[0] ? d.lender[0].id === idLender && d.type.indexOf('LOGO') > -1 : null
      );
      return doc ? doc.url : '';
    };

    const getContactName = ({ idContact, idx }) => {
      if (!_.isUuid(idContact)) {
        return idContact?.capitalizeFirstLetter() || 'N/A';
      }
      const contact = _.find(contacts || [], (c) => c?.id === idContact);
      return contact
        ? `${contact?.person?.information?.firstName} ${contact?.person?.information?.familyName}`
        : `Applicant #${idx + 1}`;
    };

    const getHouseholdName = ({ household }) => {
      let title = '-';
      if (household?.key) {
        title = household?.idContacts?.length
          ? `Household of ${_.map(
              _.filter(
                maximumBorrowing?.contacts,
                (c) => household?.idContacts.indexOf(c?.key) > -1
              ),
              (h) => getContactName({ idContact: h?.key })
            ).join(' and ')}`
          : '-';
      }
      return title;
    };

    const totalExpensesByHousehold = ({ household }) => {
      let total = 0;
      Object.keys(household).forEach((key) => {
        if (key !== 'key' && key !== 'idContacts') {
          total += household[key];
        }
      });
      return total;
    };

    const sortBy = (a, b) => {
      if (a[3].text < b[3].text) return 1;
      if (a[3].text > b[3].text) return -1;
      return 0;
    };

    const isInvestment = maximumBorrowing?.contact?.length
      ? maximumBorrowing?.contacts[0]?.liabilitiesProposed[0]?.isInvestment || false
      : false;
    const maritalStatusTable = [
      [
        {
          text: 'Name',
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        },
        {
          text: 'Status',
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        },
        {
          text: 'Spouse',
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        },
        {
          text: 'Dependents',
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        }
      ]
    ];
    const residentialStatusTable = [
      [
        {
          text: 'Name',
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        },
        {
          text: 'Status',
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        }
      ]
    ];
    const incomeTable = [
      [
        {
          text: 'Name',
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        },
        {
          text: 'Income type',
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        },
        {
          text: 'Annual amount',
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        }
      ]
    ];
    const expensesTable = [
      [
        {
          text: 'Name',
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        },
        {
          text: 'Monthly amount',
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        }
      ]
    ];
    const liabilitiesTable = [
      [
        {
          text: 'Lender',
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        },
        {
          text: 'Liability type',
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        },
        {
          text: 'Balance',
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        },
        {
          text: 'Limit',
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        },
        {
          text: 'Monthly repayment',
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        }
      ]
    ];
    for (let c = 0; c < maximumBorrowing?.contacts?.length; c += 1) {
      const contact = maximumBorrowing.contacts[c];
      const contactName = getContactName({
        idContact: contact.key,
        idx: c
      });
      const maritalStatusTableRows = [
        {
          text: contactName,
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        },
        {
          text: contact.married ? 'Married' : 'Not married',
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        },
        {
          text: getSpouse({ keySpouse: contact.keySpouse }),
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        },
        {
          text: contact.dependents,
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        }
      ];
      maritalStatusTable.push(maritalStatusTableRows);

      const residentialStatusTableRows = [
        {
          text: contactName,
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        },
        {
          text: contact?.housing?.title,
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        }
      ];
      residentialStatusTable.push(residentialStatusTableRows);

      if (contact.totalIncomeGrossSalary > 0) {
        incomeTable.push([
          {
            text: contactName,
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: 'Gross salary',
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: contact.totalIncomeGrossSalary.formatWithCurrency(currentCurrency),
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          }
        ]);
      }
      if (contact.totalIncomeAllowance > 0) {
        incomeTable.push([
          {
            text: contactName,
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: 'Allowance',
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: contact.totalIncomeAllowance.formatWithCurrency(currentCurrency),
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          }
        ]);
      }
      if (contact.totalIncomeBonus > 0) {
        incomeTable.push([
          {
            text: contactName,
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: 'Bonus',
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: contact.totalIncomeBonus.formatWithCurrency(currentCurrency),
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          }
        ]);
      }
      if (contact.totalIncomeCommissions > 0) {
        incomeTable.push([
          {
            text: contactName,
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: 'Commissions',
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: contact.totalIncomeCommissions.formatWithCurrency(currentCurrency),
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          }
        ]);
      }
      if (contact.totalIncomeOvertimeEssential > 0) {
        incomeTable.push([
          {
            text: contactName,
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: 'Overtime essential',
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: contact.totalIncomeOvertimeEssential.formatWithCurrency(currentCurrency),
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          }
        ]);
      }
      if (contact.totalIncomeOvertimeNonEssential > 0) {
        incomeTable.push([
          {
            text: contactName,
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: 'Overtime non essential',
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: contact.totalIncomeOvertimeNonEssential.formatWithCurrency(currentCurrency),
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          }
        ]);
      }
      if (contact.totalIncomeRental > 0) {
        incomeTable.push([
          {
            text: contactName,
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: 'Rental income',
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: `${contact.totalIncomeRental.formatWithCurrency(currentCurrency)} (${
              contact.totalIncomeRentalProperties === 1
                ? `${contact.totalIncomeRentalProperties} property`
                : `${contact.totalIncomeRentalProperties} properties`
            })`,
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          }
        ]);
      }
      if (contact.totalIncomeOtherTaxable > 0) {
        incomeTable.push([
          {
            text: contactName,
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: 'Other taxable income',
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: contact.totalIncomeOtherTaxable.formatWithCurrency(currentCurrency),
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          }
        ]);
      }
      if (contact.totalIncomeNonTaxable > 0) {
        incomeTable.push([
          {
            text: contactName,
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: 'Non taxable income',
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: contact.totalIncomeNonTaxable.formatWithCurrency(currentCurrency),
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          }
        ]);
      }
      if (contact.totalProfitBeforeTaxLastTaxYear > 0) {
        incomeTable.push([
          {
            text: contactName,
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: `Profit before tax last year (${contact.totalIncomeBusinessLastTaxYear})`,
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: contact.totalProfitBeforeTaxLastTaxYear.formatWithCurrency(currentCurrency),
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          }
        ]);
      }
      if (contact.totalDepreciationLastTaxYear > 0) {
        incomeTable.push([
          {
            text: contactName,
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: `Depreciation last year (${contact.totalIncomeBusinessLastTaxYear})`,
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: contact.totalDepreciationLastTaxYear.formatWithCurrency(currentCurrency),
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          }
        ]);
      }
      if (contact.totalInterestAndOtherAddBacksLastTaxYear > 0) {
        incomeTable.push([
          {
            text: contactName,
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: `Interest and other addbacks last year (${contact.totalIncomeBusinessLastTaxYear})`,
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: contact.totalInterestAndOtherAddBacksLastTaxYear.formatWithCurrency(
              currentCurrency
            ),
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          }
        ]);
      }
      if (contact.totalProfitBeforeTaxPreviousTaxYear > 0) {
        incomeTable.push([
          {
            text: contactName,
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: `Profit before tax previous year (${contact.totalIncomeBusinessPreviousTaxYear})`,
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: contact.totalProfitBeforeTaxPreviousTaxYear.formatWithCurrency(
              currentCurrency
            ),
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          }
        ]);
      }
      if (contact.totalDepreciationPreviousTaxYear > 0) {
        incomeTable.push([
          {
            text: contactName,
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: `Depreciation previous year (${contact.totalIncomeBusinessPreviousTaxYear})`,
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: contact.totalDepreciationPreviousTaxYear.formatWithCurrency(currentCurrency),
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          }
        ]);
      }
      if (contact.totalInterestAndOtherAddBacksPreviousTaxYear > 0) {
        incomeTable.push([
          {
            text: contactName,
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: `Interest and other addbacks previous year (${contact.totalIncomeBusinessPreviousTaxYear})`,
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          },
          {
            text: contact.totalInterestAndOtherAddBacksPreviousTaxYear.formatWithCurrency(
              currentCurrency
            ),
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          }
        ]);
      }

      for (let l = 0; l < contact?.liabilitiesMortgage?.length; l += 1) {
        if (!contact.liabilitiesMortgage[l]?.isRefinanced) {
          const liabilityMortgage = setLiabilityRow({
            liabilityData: contact.liabilitiesMortgage[l],
            liabilityType: 'Mortgage loan'
          });
          liabilitiesTable.push(liabilityMortgage);
        }
      }
      for (let l = 0; l < contact?.liabilitiesCreditCards?.length; l += 1) {
        if (!contact.liabilitiesCreditCards[l]?.isRefinanced) {
          const liabilityCreditCards = setLiabilityRow({
            liabilityData: contact.liabilitiesCreditCards[l],
            liabilityType: 'Credit cards',
            contactKey: contact.key
          });
          liabilitiesTable.push(liabilityCreditCards);
        }
      }
      for (let l = 0; l < contact?.liabilitiesVehicle?.length; l += 1) {
        if (!contact.liabilitiesVehicle[l]?.isRefinanced) {
          const liabilityVehicle = setLiabilityRow({
            liabilityData: contact.liabilitiesVehicle[l],
            liabilityType: 'Vehicle loan'
          });
          liabilitiesTable.push(liabilityVehicle);
        }
      }
      for (let l = 0; l < contact?.liabilitiesPersonal?.length; l += 1) {
        if (!contact.liabilitiesPersonal[l]?.isRefinanced) {
          const liabilityPersonal = setLiabilityRow({
            liabilityData: contact.liabilitiesPersonal[l],
            liabilityType: 'Personal loan'
          });
          liabilitiesTable.push(liabilityPersonal);
        }
      }
      for (let l = 0; l < contact?.liabilitiesOther?.length; l += 1) {
        if (!contact.liabilitiesOther[l]?.isRefinanced) {
          const liabilityOther = setLiabilityRow({
            liabilityData: contact.liabilitiesOther[l],
            liabilityType: 'Other loan'
          });
          liabilitiesTable.push(liabilityOther);
        }
      }
    }
    for (let e = 0; e < maximumBorrowing?.expenses?.length; e += 1) {
      const household = maximumBorrowing?.expenses[e];
      expensesTable.push([
        {
          text: getHouseholdName({ household }),
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        },
        {
          text: totalExpensesByHousehold({ household }).formatWithCurrency(currentCurrency),
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        }
      ]);
    }
    let mbDataRows = [];
    const queue = [];
    filteredLenders.forEach((lender) => {
      queue.push(
        $q.when(
          quickToolService
            .getBase64FromImageUrl({
              url: getLenderDocument({ idLender: lender.id })
            })
            .then((res) => {
              if (res?.data) {
                const mbDataRow = [
                  {
                    border: [true, true, false, true],
                    width: 18,
                    height: 18,
                    image: res.data,
                    margin: [7, 1, 3, 1],
                    style: 'tableCellCenterAlign'
                  },
                  {
                    border: [false, true, true, true],
                    text: lender.name,
                    margin: [2, 4, 0, 0],
                    style: ['tableFontSize', 'tableCellLeftAlign']
                  },
                  {
                    border: [false, true, true, true],
                    text: maximumBorrowing?.expectedRate
                      ? lender.getExpectedRate(maximumBorrowing.expectedRate)
                      : lender.getBestProductName(isInvestment),
                    margin: [2, 4, 0, 0],
                    style: ['tableFontSize', 'tableCellLeftAlign']
                  },
                  {
                    text: lender.maxBorrow.formatWithCurrency(currentCurrency),
                    margin: [2, 4, 0, 0],
                    style: ['tableFontSize', 'tableCellCenterAlign']
                  }
                ];
                mbDataRows.push(mbDataRow);
              }
            })
        )
      );
    });
    const now = moment.utc().tz(currentTimeZone).format('X');
    const date = dateTimeService.getFormattedDate(now);
    const orgLogo = currentOrganization?.organization?.logo
      ? currentOrganization.organization.logo.replace(
          /([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/gi,
          currentOrganization.id
        )
      : INSTANCE.url + INSTANCE.logo;
    $q.all(queue).then(() => {
      quickToolService.getBase64FromImageUrl({ url: orgLogo }).then((res) => {
        mbDataRows = mbDataRows.sort(sortBy);
        mbDataRows.unshift([
          {
            colSpan: 2,
            text: 'Lender',
            style: [
              'tableFontSize',
              'tableHeader',
              'tableCellLeftAlign',
              'tableCellMarginLeftTopBottom'
            ]
          },
          '',
          {
            text: maximumBorrowing?.expectedRate ? 'Expected rate' : 'Product name',
            style: [
              'tableFontSize',
              'tableHeader',
              'tableCellLeftAlign',
              'tableCellMarginLeftTopBottom'
            ]
          },
          {
            text: 'Maximum borrowing amount',
            margin: [0, 2, 0, 0],
            style: ['tableFontSize', 'tableHeader', 'tableCellCenterAlign']
          }
        ]);
        const docDefinition = {
          pageSize: 'A4',
          pageOrientation: 'portrait',
          pageMargins: [40, 40, 40, 40],
          content: [
            {
              table: {
                widths: [240, '*'],
                headerRows: 1,
                body: [
                  [
                    {
                      width: 180,
                      height: 30,
                      image: res.data,
                      margin: [5, 3, 0, 3],
                      style: 'tableHeader'
                    },
                    {
                      fillColor: '#eeeeee',
                      text: `Prepared by: ${currentAccount.getName()}\nPrepared on: ${date}`,
                      style: 'prepared'
                    }
                  ]
                ]
              },
              layout: 'noBorders'
            },
            {
              text: 'Maximum borrowing capacity summary',
              style: ['header', 'marginTop']
            }
          ],
          styles: {
            header: {
              fontSize: 16,
              bold: true
            },
            subHeader: {
              fontSize: 12,
              bold: true,
              margin: [0, 10, 0, 4]
            },
            prepared: {
              fontSize: 10,
              alignment: 'right',
              margin: [0, 6, 5, 0]
            },
            notes: {
              fontSize: 9,
              margin: [5, 5, 0, 0]
            },
            marginTop: {
              margin: [0, 10, 0, 0]
            },
            tableFontSize: {
              fontSize: 10
            },
            tableHeader: {
              fillColor: '#eee'
            },
            tableCellMarginTop: {
              margin: [0, 2, 0, 0]
            },
            tableCellMarginLeftTopBottom: {
              margin: [4, 2, 0, 2]
            },
            tableCellMarginRightTopBottom: {
              margin: [0, 2, 4, 2]
            },
            tableCellMarginTopBottom: {
              margin: [0, 2, 0, 2]
            },
            tableCellLeftAlign: {
              alignment: 'left'
            },
            tableCellRightAlign: {
              alignment: 'right'
            },
            tableCellCenterAlign: {
              alignment: 'center'
            }
          }
        };

        if (maritalStatusTable.length > 1) {
          docDefinition.content.push(
            {
              text: 'Marital status',
              style: 'subHeader'
            },
            {
              table: {
                dontBreakRows: true,
                widths: ['*', '*', '*', '*'],
                headerRows: 1,
                body: maritalStatusTable
              },
              layout: 'defaultLayout'
            }
          );
        }

        if (residentialStatusTable.length > 1) {
          docDefinition.content.push(
            {
              text: 'Post settlement residential status',
              style: 'subHeader'
            },
            {
              table: {
                dontBreakRows: true,
                widths: ['*', '*'],
                headerRows: 1,
                body: residentialStatusTable
              },
              layout: 'defaultLayout'
            }
          );
        }

        if (incomeTable.length > 1) {
          docDefinition.content.push(
            {
              text: 'Income',
              style: 'subHeader'
            },
            {
              table: {
                dontBreakRows: true,
                widths: [80, '*', 120],
                headerRows: 1,
                body: incomeTable
              },
              layout: 'defaultLayout'
            }
          );
        }

        if (expensesTable.length > 1) {
          docDefinition.content.push(
            {
              text: 'Expenses',
              style: 'subHeader'
            },
            {
              table: {
                dontBreakRows: true,
                widths: ['*', 120],
                headerRows: 1,
                body: expensesTable
              },
              layout: 'defaultLayout'
            }
          );
        }

        if (liabilitiesTable.length > 1) {
          docDefinition.content.push(
            {
              text: 'Liabilities',
              style: 'subHeader'
            },
            {
              table: {
                dontBreakRows: true,
                widths: ['*', '*', '*', '*', '*'],
                headerRows: 1,
                body: liabilitiesTable
              },
              layout: 'defaultLayout'
            },
            {
              text:
                '* Credit card repayment shown is for descriptive purposes only. Actual repayment used to determine maximum borrowing capacity relies on the lender’s specific policy and may be differentiated from the value shown.',
              style: 'notes'
            },
            {
              text:
                '** Declared student loan for maximum borrowing capacity assessment may not be relevant for all lenders. Criteria depend on each lender’s specific policy and might be fully excluded from consideration.',
              style: 'notes'
            }
          );
        }

        docDefinition.content.push(
          {
            text: 'Summary',
            style: 'subHeader'
          },
          {
            table: {
              dontBreakRows: true,
              widths: [30, '*', '*', '*'],
              headerRows: 1,
              body: mbDataRows
            },
            layout: 'defaultLayout'
          }
        );
        pdfMake.tableLayouts = {
          defaultLayout: {
            hLineWidth(i, node) {
              return i === node.table.headerRows ? 1 : 0.5;
            },
            vLineWidth() {
              return 0.5;
            },
            hLineColor(i, node) {
              return i === 0 || i === node.table.body.length ? '#333' : '#aaa';
            },
            vLineColor(i, node) {
              return i === 0 || i === node.table.widths.length ? '#333' : '#aaa';
            },
            paddingLeft() {
              return 0;
            },
            paddingRight() {
              return 0;
            },
            paddingTop() {
              return 0;
            },
            paddingBottom() {
              return 0;
            }
          }
        };
        const fileName = `${moment.utc().year()}${
          moment.utc().month() + 1
        }${moment.utc().date()}${isQuickTool ? ' Quick tools -' : ''} Maximum borrowing.pdf`;
        if (isQuickTool && !_.isEmpty(docDefinition)) {
          if (!_.isEmpty(docDefinition)) {
            if (isView) {
              pdfMake.createPdf(docDefinition).open();
            } else {
              pdfMake.createPdf(docDefinition).download(fileName);
            }
            deferred.resolve();
          }
        } else if (!isQuickTool && !_.isEmpty(docDefinition)) {
          if (isView) {
            helperPdfService.viewOrSavePdf({ docDefinition, isView: true }).then(() => {
              deferred.resolve();
            });
          } else {
            helperPdfService
              .viewOrSavePdf({
                ticket,
                docDefinition,
                fileName,
                isView: false
              })
              .then(() => {
                deferred.resolve();
              });
          }
        }
      });
    });
    return deferred.promise;
  }
});
